import { SNAPSHIFT_CLIENT_ID } from '@libs/utils/environments'

import { httpServices } from '../../../apis'
import type { QueryFnParams } from '../../../types'
import type { Profile } from '../types'

export type PostOauthGoogleResponse = {
  expires_in: number
  scope: string
  created_at: number
  user_id: string
  expires_at: Date
  info: {
    email: string
    membership_ids: any[]
    account_ids: any[]
    super_user: boolean
    draft_account_form_data: Profile
    is_account_creation_in_progress: boolean
  }
}

export type PostOauthGoogleOptions = QueryFnParams<{
  payload: {
    id_token: string
  }
}>

export const postOauthGoogle = async (opts: PostOauthGoogleOptions) => {
  const response = await httpServices.core.post<any>(
    '/oauth/front_callbacks/google',
    {
      ...opts.payload,
      application_uid: SNAPSHIFT_CLIENT_ID
    }
  )
  return response.data
}
